import { Badge } from "@chakra-ui/react";
import { useMemo } from "react";

interface PartTypeInterface {
    partType: string;
}

const PartType = ({ partType }: PartTypeInterface) => {

    const color = useMemo(() => {
        const type = partType?.toUpperCase() ?? "N/A";
        if (type.includes("OEM") || type.includes("OE")) return "blue";
        if (type.includes("AFTERMARKET") || type.includes("A/M") || type.includes("AM") || type.includes("CAPA")) return "teal";
        if (type.includes("RECYCLED") || type.includes("LKQ") || type.includes("RCY") || type.includes("USED")) return "gray";
        if (type.includes("RE-CON") || type.includes("RECON") || type.includes("RE-MAN") || type.includes("REMAN")) return "orange";
        if (type === 'N/A') return "red";
        return "purple"; // Unknown types
    }, [partType]);

    return (
        <Badge
            colorScheme={color}
            variant="subtle"
            px={2}
            py={1}
            borderRadius="lg"
            fontSize="xs"
            fontWeight="medium"
        >
            {partType}
        </Badge>
    );
};

export default PartType;